import React from 'react'
import style from './MiniSpinner.module.css'

function MiniSpinner() {
  return (
    <div className={style.spinner}></div>
  )
}

export default MiniSpinner